// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pkzusxhvdofvmdiwuwjy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBrenVzeGh2ZG9mdm1kaXd1d2p5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3MTM0NjEsImV4cCI6MjA3NjI4OTQ2MX0.ET_azLDJtEzLPEYMKEqi92waP8moli2yr5hBbyml4Ak";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});